// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__3LFDG","active":"Loader_active__2r-Nz","icon":"Loader_icon__2caYb","rotate":"Loader_rotate__2CUi0","message":"Loader_message__Eh5w8"};